import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  paper: {
    [theme.breakpoints.up('md')]: {
      minWidth: 640,
    },
  },
  dialogContent: {
    textAlign: 'center',
    padding: '50px 48px 47px !important',
  },
  heading: {
    fontSize: 26,
    color: '#000',
    fontWeight: 700,
    lineHeight: 1.5,
    marginBottom: 25,
  },
  balance: {
    marginBottom: 31,
  },
  amount: {
    marginBottom: 62,
  },
  error: {
    color: '#f44336',
  },
  fieldWrapper: {
    width: '100%',
    maxWidth: 422,
    margin: '0 auto',
  },
  inputField: {
    '& input': {
      fontSize: 24,
      fontWeight: 600,
      padding: '14px 29px',
      borderColor: '#dddfe1',
      borderRadius: 13,
      '&::placeholder': {
        color: '#707070',
        fontWeight: 400,
        opacity: 1,
      },
    },
  },
  button: {
    borderRadius: 13,
    boxShadow: '0 3px 13px #c6e5ff',
    padding: '12px 16px',
  },
  buttonLabel: {
    fontSize: 19,
    fontWeight: 600,
    textTransform: 'none',
  },
}));
